import { api } from '../../lib/api-client';

/**
 * 0 = PdfDocument, 1 = NumericScore, 2 = ExternalEmbed.
 * Espejo de `Scouting.Model.EvaluationType`.
 */
export type EvaluationType = 0 | 1 | 2;

export type EvaluationItem = {
  /** `CandidateEvaluation.PublicKey` Guid. */
  id: string;
  type: EvaluationType;
  title: string;
  /** Solo cuando type = NumericScore. */
  score: number | null;
  /** Solo cuando type = NumericScore. Si null, mostrar solo el score. */
  maxScore: number | null;
  /** Para NumericScore o ExternalEmbed: nombre del proveedor. */
  provider: string | null;
  /** Solo cuando type = ExternalEmbed. URL pública. */
  externalUrl: string | null;
};

export type EvaluationsResponse = {
  items: EvaluationItem[];
};

export type EvaluationPdfUrlResponse = {
  url: string;
  expiresAt: string;
  mimeType: string;
};

export type ListEvaluationsParams = {
  shortlistPublicKey: string;
  talentPublicKey: string;
};

export type EvaluationPdfUrlParams = ListEvaluationsParams & {
  evaluationPublicKey: string;
};

export async function listTalentEvaluations(
  params: ListEvaluationsParams,
): Promise<EvaluationsResponse> {
  const url =
    `/api/client/shortlists/${params.shortlistPublicKey}` +
    `/talents/${params.talentPublicKey}/evaluations`;
  return api.get<EvaluationsResponse>(url);
}

export async function getEvaluationPdfUrl(
  params: EvaluationPdfUrlParams,
): Promise<EvaluationPdfUrlResponse> {
  const url =
    `/api/client/shortlists/${params.shortlistPublicKey}` +
    `/talents/${params.talentPublicKey}` +
    `/evaluations/${params.evaluationPublicKey}/pdf-url`;
  return api.get<EvaluationPdfUrlResponse>(url);
}
